<template>
  <div class="modal" @click="$emit('close')">
    <div class="content" @click="$event.stopPropagation()">
      <div class="header">
        <p class="title">COVID-19</p>
        <img class="close" src="@/assets/icons/close.svg" @click="$emit('close')" />
      </div>
      <p class="description">
        Konferencija je organizirana u skladu s epidemiološkim mjerama. Poštivanje razmaka, redovito korištenje
        dezinficijensa i nošenje maski je obavezno za sve sudionike.
      </p>
      <div class="icons-wrapper">
        <div class="icon"><img src="@/assets/icons/covid/distancing.svg" /></div>
        <div class="icon"><img src="@/assets/icons/covid/wash-hands.svg" /></div>
        <div class="icon"><img src="@/assets/icons/covid/batman.svg" /></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CovidModal',
};
</script>

<style scoped>
.modal {
  display: flex;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100000;
  overflow-y: hidden;
  background-color: rgba(0, 0, 0, 0.4);
}

.content {
  width: 340px;
  height: 340px;
  margin-top: auto;
  margin-bottom: auto;
  background-color: #162426;
  border-radius: 20px;
  padding: 24px;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 34px;
}

.title {
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  color: rgba(255, 255, 255, 0.8);
}

.close {
  cursor: pointer;
}

.description {
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  margin-bottom: 40px;
}

.icons-wrapper {
  display: flex;
}

.icon {
  width: 64px;
  height: 64px;
  border-radius: 13px;
  background-color: rgba(255, 255, 255, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon:not(:last-child) {
  margin-right: 16px;
}
</style>
